<template>
  <a-row class="h-100 px-3 d-flex justify-content-evenly" :gutter="[24, 0]">
    <a-col
      v-for="entity in config"
      :key="entity.key"
      span="8"
      class="d-flex flex-column"
    >
      <a-input-group compact class="w-100 d-flex">
        <a-input
          v-model:value="newEntity[entity.key]"
          @pressEnter="entity.createHandler(entity.key, entity.name)"
        />
        <a-button
          type="primary"
          :disabled="!newEntity[entity.key]"
          @click="entity.createHandler(entity.key, entity.name)"
        >
          <template #icon>
            <plus-outlined />
          </template>
          Add {{ entity.name }}
        </a-button>

        <a-dropdown
          v-if="entity.key === 'staticRegions'"
          :disabled="isNavigationDropdownDisabled(entity.key)"
        >
          <template #overlay>
            <a-menu @click="(e) => handleAddNavObjects(e, entity.key)">
              <template v-for="item in staticTriggerList">
                <a-menu-item
                  v-if="!enabledStaticTriggers.has(item.object)"
                  :key="item.object"
                >
                  Add {{ item.object }}
                </a-menu-item>
              </template>
            </a-menu>
          </template>
          <a-button
            type="default"
            @click="entity.createHandler(entity.key, entity.name)"
          >
            <template #icon>
              <plus-outlined />
            </template>
            <DownOutlined />
          </a-button>
        </a-dropdown>
      </a-input-group>

      <a-list
        class="mt-2 flex-grow-1 d-flex flex-column entity-list"
        style="height: 1px !important"
        bordered
        :data-source="listData[entity.key]"
        size="small"
      >
        <template #renderItem="{ item }">
          <a-list-item
            class="entity-list-item"
            :class="{ 'checked-list-item': item.is_3d }"
            :style="{ 'align-items': 'center' }"
          >
            <a-typography-text v-if="editingEntityId !== item.id">
              <span :class="'mr-2 item-type-' + entity.key">{{
                item.name
              }}</span>
              <span class="text-primary" @click="onClickEditEntity(item)">
                <EditOutlined
                  v-if="
                    !isHandAndFaceObj(item.name, modelChoice) &&
                    !isDefaultObjects(item.name)
                  "
                />
              </span>
            </a-typography-text>

            <a-input-group
              v-if="editableObj && editingEntityId === item.id"
              compact
            >
              <a-input
                v-model:value="editableObj.name"
                style="width: calc(100% - 100px)"
                @change="changeEntity"
                @pressEnter="entity.endHandler(entity.key, entity.name)"
              />
              <a-tooltip title="Update">
                <a-button @click="entity.endHandler(entity.key, entity.name)">
                  <template #icon><EnterOutlined /></template>
                </a-button>
              </a-tooltip>
            </a-input-group>

            <template v-if="entity.key === 'staticRegions'" #actions>
              <template v-if="listData.planeRegions.length > 0">
                <template v-if="item.is_3d">
                  <a-select
                    ref="select"
                    v-model:value="item.plane_id"
                    :style="{
                      width: item.is_3d ? '8vw' : '5vw',
                    }"
                    placeholder="add plane"
                    @change="(value) => addPlaneToObject(value, item.id)"
                  >
                    <a-select-option
                      v-for="plane in listData.planeRegions"
                      :value="plane.id"
                      >{{ plane.name }}</a-select-option
                    >
                  </a-select>

                  <div style="display: flex; width: 8vw">
                    <a-input-number
                      id="inputNumber"
                      v-model:value="item.plane_threshold"
                      :min="1"
                      :max="100"
                      @change="(value) => changeThreshold(item, value)"
                    />

                    <span
                      class="ml-2"
                      style="display: flex; align-items: center; color: black"
                    >
                      cm
                    </span>
                  </div>
                </template>

                <a-checkbox
                  v-model:checked="item.is_3d"
                  @change="(event) => setObject3D(event, item)"
                >
                  3D
                </a-checkbox>
              </template>
              <template v-if="!isHandAndFaceObj(item.name, modelChoice)">
                <a-popconfirm
                  cancel-text="No"
                  ok-text="Yes"
                  title="Are you sure you want to delete this object?"
                  @confirm="entity.deleteHandle(item)"
                >
                  <delete-outlined
                    style="padding-top: 0.6vh"
                    class="text-danger clickable"
                  />
                </a-popconfirm>
              </template>
            </template>

            <template v-else #actions>
              <a-space>
                <a-input-number
                  v-if="
                    advanceFeatures['Confidence'] &&
                    !isHandAndFaceObj(item.name, modelChoice)
                  "
                  v-model:value="item.confidence"
                  placeholder="Confidence"
                  style="width: 70px"
                  :min="0.1"
                  :max="1.0"
                  :step="0.1"
                  @change="handleChangeObjectConfidence(item)"
                  @keydown="(e) => handlePressEnterConfidence(e, item)"
                />
                <input
                  v-model="item.object"
                  type="checkbox"
                  :checked="item.is_object_visible"
                  style="margin: 0 8px"
                  @change="handleChangeObjectVisibility(item, 'object')"
                />
                Show Objects

                <!-- Checkbox 2 -->
                <input
                  v-model="item.label"
                  type="checkbox"
                  :checked="item.is_label_visible"
                  :disabled="!item.is_object_visible"
                  style="margin: 0 8px"
                  @change="handleChangeObjectVisibility(item, 'label')"
                />
                Show labels
                <input
                  v-if="!isHandAndFaceObj(item.name, modelChoice)"
                  v-model="item.outline_color"
                  :disabled="isHandAndFaceObj(item.name, modelChoice)"
                  type="color"
                  :style="{
                    width: '15px',
                    height: '15px',
                    padding: '0',
                    backgroundColor: isHandAndFaceObj(item.name, modelChoice)
                      ? '#f5f5f5'
                      : '',
                    borderColor: isHandAndFaceObj(item.name, modelChoice)
                      ? '#d9d9d9'
                      : '',
                    cursor: isHandAndFaceObj(item.name, modelChoice)
                      ? 'not-allowed'
                      : 'pointer',
                    opacity: isHandAndFaceObj(item.name, modelChoice)
                      ? '0.6'
                      : '1',
                  }"
                  @change="handleChangeObjectColor(item)"
                  @keyup="(e) => handlePressEnter(e, item)"
                />
                <template
                  v-if="
                    listData.planeRegions.length > 0 &&
                    !isHandAndFaceObj(item.name, modelChoice)
                  "
                >
                  <a-checkbox
                    v-model:checked="item.is_3d"
                    @change="(value) => setObject3D(value, item)"
                  >
                    3D
                  </a-checkbox>
                  <template v-if="item.is_3d">
                    <a-select
                      ref="select"
                      v-model:value="item.plane_id"
                      style="width: 5vw"
                      @change="(value) => addPlaneToObject(value, item.id)"
                    >
                      <a-select-option
                        v-for="plane in listData.planeRegions"
                        :value="plane.id"
                        >{{ plane.name }}</a-select-option
                      >
                    </a-select>
                    <a-input-number
                      id="inputNumber"
                      v-model:value="item.plane_threshold"
                      :min="1"
                      :max="100"
                      @change="(value) => changeThreshold(item, value)"
                    />
                  </template>
                </template>
                <template
                  v-if="
                    !isHandAndFaceObj(item.name, modelChoice) &&
                    !isDefaultObjects(item.name)
                  "
                >
                  <a-popconfirm
                    cancel-text="No"
                    ok-text="Yes"
                    title="Are you sure you want to delete this object?"
                    @confirm="entity.deleteHandle(item)"
                  >
                    <delete-outlined
                      :style="{
                        paddingTop: '0.6vh',
                        color: isHandAndFaceObj(item.name, modelChoice)
                          ? 'gray'
                          : 'red',
                        cursor: isHandAndFaceObj(item.name, modelChoice)
                          ? 'not-allowed'
                          : 'pointer',
                      }"
                      :class="{
                        clickable: !isHandAndFaceObj(item.name, modelChoice),
                      }"
                    />
                  </a-popconfirm>
                </template>
                <template v-else>
                  <a-switch
                    v-if="isDefaultObjects(item.name)"
                    :checked="item.trigger_type !== null ? true : false"
                    @click="handleDefaultObjectTrigger(item)"
                  />
                </template>
              </a-space>
            </template>
          </a-list-item>
        </template>
        <template #header>
          <span>{{ entity.name }}s</span>
        </template>
      </a-list>
    </a-col>
    <a-col span="6" class="d-flex flex-column">
      <a-input-group compact class="w-100 d-flex">
        <a-input
          v-model:value="newEntity.planeRegions"
          @pressEnter="handleAddPlane()"
        />
        <a-button
          type="primary"
          :disabled="!newEntity.planeRegions"
          :loading="planeLoading"
          @click="handleAddPlane()"
        >
          Add {{ 'Planes' }}
          <template #icon>
            <plus-outlined />
          </template>
        </a-button>
      </a-input-group>

      <a-list
        class="mt-2 flex-grow-1 d-flex flex-column entity-list"
        style="height: 1px !important"
        bordered
        :data-source="listData.planeRegions"
        size="small"
      >
        <template #renderItem="{ item }">
          <a-list-item class="entity-list-item">
            <a-typography-text v-if="editingEntityId !== item.id">
              <span class="mr-2 item-type-planeRegions">{{ item.name }}</span>
              <span class="text-primary" @click="onClickPlaneEditEntity(item)">
                <EditOutlined
                  v-if="!isHandAndFaceObj(item.name, modelChoice)"
                />
              </span>
            </a-typography-text>
            <a-input-group
              v-if="editableObj && editingEntityId === item.id"
              compact
            >
              <a-input
                v-model:value="editableObj.name"
                style="width: calc(100% - 100px)"
                @change="changeEntity"
                @pressEnter="handleUpdatePlaneEntity(item.name)"
              />
              <a-tooltip title="Update">
                <a-button
                  :loading="updatePlaneLoading"
                  @click="handleUpdatePlaneEntity(item.name)"
                >
                  <template #icon><EnterOutlined /></template>
                </a-button>
              </a-tooltip>
            </a-input-group>
            <template v-if="!isHandAndFaceObj(item.name, modelChoice)" #actions>
              <a-popconfirm
                cancel-text="No"
                ok-text="Yes"
                title="Are you sure you want to delete this plane?"
                @confirm="handleDeletePlaneObject(item.id)"
              >
                <delete-outlined class="text-danger clickable" />
              </a-popconfirm>
            </template>
          </a-list-item>
        </template>
        <template #header>
          <span>{{ 'Planes' }}</span>
        </template>
      </a-list>
    </a-col>
  </a-row>
</template>
<script>
import {
  DeleteOutlined,
  DownOutlined,
  EditOutlined,
  EnterOutlined,
} from '@ant-design/icons-vue';
import { getRandomColor } from 'src/config/color-config';
import { isHandAndFaceObj } from 'src/utils/detector';
import { deepClone } from 'src/utils/task';
import { mapActions, mapGetters } from 'vuex';
import {
  defaultObjects,
  isDefaultObjects,
  staticTriggers,
  triggerType,
} from './config';

export default {
  components: {
    DeleteOutlined,
    EditOutlined,
    EnterOutlined,
    DownOutlined,
  },
  inject: ['toast'],
  props: ['pipelineStep', 'nextStep', 'handleDone'],
  setup() {
    return {
      triggerType,
      staticTriggers,
      defaultObjects,
      isHandAndFaceObj,
      isDefaultObjects,
    };
  },
  data() {
    return {
      planeLoading: false,
      updatePlaneLoading: false,
      editingEntityId: null,
      listData: {
        objects: [],
        staticRegions: [],
        planeRegions: [],
      },
      newEntity: {
        objects: '',
        staticRegions: '',
        planeRegions: '',
      },
      // for renaming
      editableObj: { name: null },
      oldEntity: null,
      oldPlaneEntity: null,
      planeThresholdEditEntity: null,
      darkRedColor: '#ff0000',
    };
  },

  computed: {
    ...mapGetters([
      'taskObjects',
      'selectedTask',
      'planeObjectsList',
      'isTask3d',
      'modelChoice',
      'advanceFeatures',
    ]),

    config() {
      return [
        {
          name: 'Object',
          key: 'objects',
          createHandler: this.handleAddEntity,
          endHandler: this.handleUpdateEntity,
          deleteHandle: this.handleDeleteEntity,
        },
        {
          name: 'Static Region',
          key: 'staticRegions',
          createHandler: this.handleAddEntity,
          endHandler: this.handleUpdateEntity,
          deleteHandle: this.handleDeleteEntity,
        },
      ];
    },

    enabledStaticTriggers() {
      return new Set(
        this.taskObjects
          .filter((item) => item.is_static)
          .map((item) => item.name)
      );
    },

    staticTriggerList() {
      return Object.values(staticTriggers).filter(
        (item) => !this.isDefaultStaticObjectEnabled(item.object)
      );
    },
  },

  watch: {
    taskObjects() {
      this.updateTaskObjectsAndStaticRegions();
    },
  },

  async mounted() {
    await this.addDefaultObjectsForModelAD();
    this.updateTaskObjectsAndStaticRegions();
    await this.getTaskPlaneObjectsList();
    this.setPrevGroups({ labels: {}, rectangles: {} });
    this.setPrevPolygons({ labels: {}, lines: {} });
    this.listData.planeRegions = this.planeObjectsList;
  },
  methods: {
    ...mapActions([
      'addTaskObject',
      'updateTaskObject',
      'deleteTaskObject',
      'getTaskPlaneObjectsList',
      'createNewPlane',
      'addPlaneObject',
      'deletePlaneObject',
      'getTaskObjects',
      'setPrevGroups',
      'setPrevPolygons',
      'fetchTaskDetails',
      'updateTaskObjectStateOnly',
    ]),

    isDefaultStaticObjectEnabled(obj) {
      return this.taskObjects.some(
        (item) => item.is_static && item.name === obj
      );
    },

    async handleDefaultObjectTrigger(obj) {
      if (!obj.trigger_type) {
        this.setObjectTriggerType(obj.name, obj);
      } else {
        obj.trigger_type = null;
      }
      const new_payload = { objectData: obj, objectId: obj.id };
      await this.updateTaskObject(new_payload);
    },

    async handleAddNavObjects(e, key) {
      const object = e.key;
      if (key == 'staticRegions') {
        const payload = {
          name: object,
          task: this.selectedTask,
          outline_color: getRandomColor(),
          is_static: true,
        };

        this.setObjectTriggerType(object, payload);
        this.addTaskObject(payload);
        return;
      }

      const obj = this.getObjectIdFromTaskObjects(object);
      obj.outline_color = getRandomColor();

      this.setObjectTriggerType(object, obj);

      const new_payload = { objectData: obj, objectId: obj.id };

      await this.updateTaskObject(new_payload);
    },

    setObjectTriggerType(object, payload) {
      if (
        object === triggerType.Previous ||
        object === staticTriggers.PreviousStatic.object
      ) {
        payload.trigger_type = triggerType.Previous;
      } else if (
        object === triggerType.Next ||
        object === staticTriggers.NextStatic.object
      ) {
        payload.trigger_type = triggerType.Next;
      } else if (
        object === triggerType.CycleStart ||
        object === staticTriggers.CycleStartStatic.object
      ) {
        payload.trigger_type = triggerType.CycleStart;
      } else if (
        object === triggerType.CycleEnd ||
        object === staticTriggers.CycleEndStatic.object
      ) {
        payload.trigger_type = triggerType.CycleEnd;
      }
    },

    async handleChangeObjectColor(object) {
      await this.updateTaskObject({
        objectId: object.id,
        objectData: { ...object },
      });
    },
    async handleChangeObjectConfidence(object) {
      await this.updateTaskObject({
        objectId: object.id,
        objectData: { ...object },
      });
    },
    async handleChangeObjectVisibility(item, type) {
      if (type === 'object') {
        item.is_object_visible = !item.is_object_visible;
        if (!item.is_object_visible) {
          item.is_label_visible = false;
        }
      } else if (type === 'label') {
        item.is_label_visible = !item.is_label_visible;
      }
      this.setItemInLocalStorage(item);
    },

    setItemInLocalStorage(item) {
      let ODObjects = JSON.parse(localStorage.getItem('ODObjects')) || {};
      ODObjects[item.id] = {
        objectVisible: item.is_object_visible,
        labelVisible: item.is_label_visible,
      };
      localStorage.setItem('ODObjects', JSON.stringify(ODObjects));
    },

    async handlePressEnter(e, object) {
      if (e.keyCode === 13) await this.handleChangeObjectColor(object);
    },
    async handlePressEnterConfidence(event, object) {
      // Allow arrow keys and prevent other manual text inputs
      const allowedKeys = ['ArrowUp', 'ArrowDown', 'Backspace', 'Delete', '.'];
      const isDigit = /^[0-9]$/.test(event.key);

      if (!allowedKeys.includes(event.key) && !isDigit) {
        event.preventDefault();
      }
    },

    setOldEntity() {
      this.oldEntity = this.taskObjects.find(
        (obj) => obj.id === this.editingEntityId
      );
    },

    setOldPlainEntity() {
      this.oldPlaneEntity = this.planeObjectsList.find(
        (o) => o.id === this.editingEntityId
      );
    },

    changeEntity(e) {
      const updateValue = e.target.value;
      if (!this.editingEntityId) return;
      if (this.isHandAndFaceObj(updateValue, this.modelChoice)) {
        this.oldEntity = null;
        this.oldPlaneEntity = null;
        this.editingEntityId = null;
        this.editableObj = { name: null };
      }
    },

    onClickEditEntity(item) {
      this.editingEntityId = item.id;
      this.setOldEntity();
      this.editableObj = { ...item };
    },

    onClickPlaneEditEntity(item) {
      this.editingEntityId = item.id;
      this.setOldPlainEntity();
      this.editableObj = { ...item };
    },

    isEntityExists(key, name = 'objects') {
      const entityExist = this.listData[key].some(
        (obj) => obj.name.toLowerCase() === this.newEntity[key].toLowerCase()
      );
      if (entityExist) {
        this.toast.error(`You can not create duplicate ${name}!`);
        return true;
      }
      return false;
    },

    isAddingDefaultObjects(key, name = 'objects') {
      if (this.isHandAndFaceObj(this.newEntity[key], this.modelChoice)) {
        this.toast.error(`You can not add default ${name}!`);
        return true;
      }
      if (this.isDefaultObjects(this.newEntity[key])) {
        this.toast.error(`You can not create default ${name}.`);
        return true;
      }
      return false;
    },

    isValidPattern(value) {
      const pattern = new RegExp(
        '^[A-Za-z](?:[A-Za-z0-9_-]*[A-Za-z0-9])?(?: [A-Za-z0-9_-]+)*$'
      );
      return pattern.test(value);
    },

    async setObject3D(event, item) {
      const listOfObjectAndStaticRegions = [
        ...this.listData.objects,
        ...this.listData.staticRegions,
      ];
      if (event.target.checked == false && item.plane_id) {
        const updatedObject = listOfObjectAndStaticRegions.find(
          (object) => object.id == item.id
        );
        let payload = {
          ...updatedObject,
          is_3d: false,
          plane_id: null,
        };
        await this.updateTaskObject({
          objectId: item.id,
          objectData: payload,
        });
      } else {
        const listOfStaticRegions = [...this.listData.staticRegions];
        const listOfObjects = [...this.listData.objects];
        this.listData['staticRegions'] = listOfStaticRegions.map((region) =>
          region.is_3d && region.plane_id
            ? region
            : region.id === item.id
            ? { ...region, is_3d: event.target.checked }
            : { ...region, is_3d: false }
        );

        this.listData['objects'] = listOfObjects.map((object) =>
          object.is_3d && object.plane_id
            ? object
            : object.id === item.id
            ? { ...object, is_3d: event.target.checked }
            : { ...object, is_3d: false }
        );
      }
    },

    async addDefaultObjects() {
      if (this.modelChoice == 'Model D') {
        return;
      }
      const taskObjects = deepClone(this.taskObjects);
      const defaultNames = this.defaultObjects.slice(2);
      const notFoundDefaultObjects = defaultNames.filter(
        (name) =>
          taskObjects.find((obj) => !obj.is_static && obj.name === name) ===
          undefined
      );
      if (notFoundDefaultObjects.length) {
        await Promise.all(
          notFoundDefaultObjects.map((item) => this.addObject(item))
        );
      }
    },

    async updateTaskObjectsAndStaticRegions() {
      await this.addDefaultObjects();
      const taskObjects = deepClone(this.taskObjects);
      const filteredObjects = this.sortObjects(
        taskObjects.filter((obj) => {
          return !obj.cordinates_of_static_object && !obj.is_static;
        })
      );

      const defaultSorted = this.defaultObjects
        .map((name) => filteredObjects.find((obj) => obj.name === name))
        .filter(Boolean);
      const remaining = filteredObjects.filter(
        (obj) => !this.defaultObjects.includes(obj.name)
      );

      const objects = [...defaultSorted, ...remaining];

      const staticRegions = taskObjects.filter((obj) => obj.is_static);

      this.updateObjectOutlineColor(objects);
      this.listData = {
        objects,
        staticRegions,
        planeRegions: this.planeObjectsList,
      };
    },

    updateObjectOutlineColor(objects) {
      objects.forEach((item) => {
        item.outline_color = item.outline_color ?? this.darkRedColor;
      });
    },

    sortObjects(objects) {
      //place hands and faces at the end of list
      const priority = {
        hands: 1,
        faces: -1,
      };

      objects.sort(function (a, b) {
        if (
          priority.hasOwnProperty(a.name) &&
          priority.hasOwnProperty(b.name)
        ) {
          return priority[b.name];
        }
        if (priority.hasOwnProperty(a.name)) {
          return -1;
        }
      });
      return objects;
    },

    async addDefaultObjectsForModelAD() {
      let is_new_obj_added = false;
      if (this.modelChoice == 'Model D') {
        return;
      }
      if (
        this.modelChoice !== 'Model ADF' &&
        !this.objectExistInTaskObjects(this.defaultObjects[0])
      ) {
        await this.addObject(this.defaultObjects[0]);
      }

      if (!this.objectExistInTaskObjects(this.defaultObjects[1])) {
        await this.addObject(this.defaultObjects[1]);
      }

      if (this.modelChoice === 'Model ADF') {
        let handsObject = this.taskObjects.find((obj) => obj.name === 'hands');
        if (handsObject != null) await this.deleteTaskObject(handsObject.id);
      }

      if (is_new_obj_added) {
        await this.getTaskObjects(this.selectedTask);
      }
    },

    isEntityDisabled(obj) {
      return this.defaultObjects.includes(obj);
    },

    async addObject(object_name) {
      const payload = {
        name: object_name,
        task: this.selectedTask,
      };
      await this.addTaskObject(payload);
    },

    objectExistInTaskObjects(object_name) {
      return this.taskObjects.some((taskObj) => taskObj.name === object_name);
    },

    getObjectIdFromTaskObjects(object_name) {
      const foundObj = this.taskObjects.find(
        (taskObj) => taskObj.name === object_name
      );
      return foundObj ? foundObj : null;
    },

    async changeThreshold(item, value = null) {
      let payload = {
        ...item,
        plane_threshold: value
          ? value
          : this.planeThresholdEditEntity.plane_threshold,
      };
      if (value) {
        await this.updateTaskObject({
          objectId: item.id,
          objectData: payload,
        });
      } else if (
        item.plane_threshold !== this.planeThresholdEditEntity.plane_threshold
      ) {
        await this.updateTaskObject({
          objectId: item.id,
          objectData: payload,
        });
      }
      this.planeThresholdEditEntity = null;
    },

    isObjectOrStaticRegionExist(name, id = null) {
      const listOfObjectAndStaticRegions = [
        ...this.listData.objects,
        ...this.listData.staticRegions,
      ];

      let entityExist = false;
      if (id !== null) {
        entityExist = listOfObjectAndStaticRegions.some(
          (obj) =>
            obj.id !== this.editingEntityId &&
            obj.name.toLowerCase() === name.toLowerCase()
        );
      } else {
        entityExist = listOfObjectAndStaticRegions.some(
          (obj) => obj.name.toLowerCase() === name.toLowerCase()
        );
      }

      if (entityExist) {
        this.toast.error(`You can not create duplicate items!`);
        return true;
      }
      return false;
    },

    handleAddEntity(key, name) {
      if (!this.newEntity[key]) return;
      if (this.isAddingDefaultObjects(key, name)) return;
      if (!this.isValidPattern(this.newEntity[key])) {
        this.toast.info(
          `${name} name should only contains valid Alpha numeric words!`
        );
        return;
      }
      if (this.newEntity[key].length > 20) {
        return this.toast.info(`${name} name should not exceed 20 characters!`);
      }
      if (this.isObjectOrStaticRegionExist(this.newEntity[key])) return;
      const payload = {
        name: this.newEntity[key],
        task: this.selectedTask,
        outline_color: getRandomColor(),
      };
      if (key === 'staticRegions') payload['is_static'] = true;
      this.addTaskObject(payload);
      this.newEntity[key] = '';
    },

    async addPlaneToObject(value, id) {
      const listOfObjectAndStaticRegions = [
        ...this.listData.objects,
        ...this.listData.staticRegions,
      ];
      const updatedObject = listOfObjectAndStaticRegions.find(
        (data) => data.id == id
      );
      const updatedListEntity = this.listData.planeRegions.find(
        (plane) => plane.id == value
      );
      let payload = {
        ...updatedObject,
        is_3d: true,
        plane_id: updatedListEntity.id,
      };

      await this.updateTaskObject({
        objectId: id,
        objectData: payload,
      });
    },

    getRandomInt(min, max) {
      min = Math.ceil(min);
      max = Math.floor(max);
      return Math.floor(Math.random() * (max - min)) + min;
    },

    async handleAddPlane() {
      if (!this.isTask3d) {
        this.toast.error('Defined task is not 3d!');

        return;
      }
      const key = 'planeRegions';
      if (this.isAddingDefaultObjects(key)) return;
      if (this.isEntityExists(key)) return;
      const name = this.newEntity.planeRegions;
      if (!this.isValidPattern(name)) {
        this.toast.info(
          'Plain name should only contains valid Alpha numeric words!'
        );
        return;
      }
      this.planeLoading = true;
      await this.createNewPlane({
        task: this.selectedTask,
        points: JSON.stringify({ plane_points: [] }),
        type: 'Workbench',
        tolerance: 10.0,
        name: name,
      });
      await this.getTaskPlaneObjectsList();
      this.listData.planeRegions = this.planeObjectsList;
      this.newEntity['planeRegions'] = '';
      this.planeLoading = false;
    },

    async handleUpdateEntity(key, objectName) {
      if (!this.editingEntityId) return;
      const oldEntity = this.taskObjects.find(
        (obj) => obj.id === this.editingEntityId
      );
      if (this.editableObj.name.length > 20)
        return this.toast.info(
          `${objectName} name should not exceed 20 characters!`
        );
      if (!this.isValidPattern(this.editableObj.name)) {
        this.toast.info(
          `${objectName} name should only contains valid Alpha numeric words!`
        );
        return;
      }
      if (
        this.isObjectOrStaticRegionExist(
          this.editableObj.name,
          this.editingEntityId
        )
      )
        return;
      if (this.editableObj.name !== oldEntity.name) {
        await this.updateTaskObject({
          objectId: oldEntity.id,
          objectData: { ...this.editableObj },
        });
      }
      this.editingEntityId = null;
      this.oldEntity = null;
      this.editableObj = { name: null };
    },

    async handleUpdatePlaneEntity(updatedName) {
      if (!this.editingEntityId) return;
      if (this.editableObj.name.length > 20)
        return this.toast.info(
          `${this.editableObj.name} name should not exceed 20 characters!`
        );
      if (!this.isValidPattern(this.editableObj.name)) {
        this.toast.info(
          'Plane name should only contains valid Alpha numeric words!'
        );
        return;
      }
      const entityExist = this.listData['planeRegions'].some(
        (obj) =>
          obj.id !== this.editingEntityId &&
          obj.name.toLowerCase() === this.editableObj.name.toLowerCase()
      );
      if (entityExist) {
        return this.toast.error(`You can not create duplicate planeRegions!`);
      }
      const oldEntity = this.planeObjectsList.find(
        (obj) => obj.id === this.editingEntityId
      );
      if (this.editableObj.name !== oldEntity.name) {
        this.updatePlaneLoading = true;
        const updatedEntity = this.editableObj;
        await this.addPlaneObject(updatedEntity);
        await this.getTaskPlaneObjectsList();
        this.listData.planeRegions = this.planeObjectsList;
      }
      this.oldPlaneEntity = null;
      this.editingEntityId = null;
      this.editableObj = { name: null };
      this.updatePlaneLoading = false;
    },

    async handleDeleteEntity(object) {
      await this.deleteTaskObject(object.id);
      await this.fetchTaskDetails(this.selectedTask);
      await this.getTaskObjects(this.selectedTask);
    },

    async handleDeletePlaneObject(id) {
      await this.deletePlaneObject(id);
      await this.getTaskPlaneObjectsList();
      this.updateTaskObjectList(id);
    },

    updateTaskObjectList(id) {
      this.listData.planeRegions = this.planeObjectsList;
      this.listData.objects.forEach((object) => {
        if (object.is_3d && object.plane_id == id) {
          object.plane_id = null;
        }
      });

      this.listData.staticRegions.forEach((region) => {
        if (region.is_3d && region.plane_id == id) {
          region.plane_id = null;
        }
      });
      const listOfObjectAndStaticRegions = [
        ...this.listData.objects,
        ...this.listData.staticRegions,
      ];
      this.updateTaskObjectStateOnly(listOfObjectAndStaticRegions);
    },

    isNavigationDropdownDisabled(key) {
      if (key !== 'staticRegions') return false;
      const object = Object.values(staticTriggers).map((item) => item.object);
      let flag = true;
      for (let index = 0; index < object.length; index++) {
        if (this.isDefaultStaticObjectEnabled(object[index])) continue;
        flag = false;
        return flag;
      }
      return flag;
    },
  },
};
</script>
<style>
.entity-list > .ant-list-header {
  background: lightgray !important;
  font-weight: 600 !important;
}

.entity-list > .ant-spin-nested-loading {
  overflow-y: auto;
}

.entity-list-item:hover {
  background: rgb(231, 231, 231);
}

.entity-list-item ul.ant-list-item-action {
  margin-left: 0;
}

.checked-list-item.ant-list-item {
  display: block;
}

.checked-list-item ul.ant-list-item-action {
  margin-top: 5px;
  display: flex;
  justify-content: space-between;
  flex: 1;
  align-items: center;
}
</style>
